/**
 * Utilidades para geração de caminhos de salvamento de Pré-Orçamentos
 */

import { buildPreOrcamentoDirFromParams, generatePreOrcFileNameFromParams } from './fileNaming';

function pad2(n: number): string { return String(n).padStart(2, '0'); }
function pad3(n: number | string): string { return String(n).padStart(3, '0'); }

/**
 * Converte um nome em um slug simples: minúsculas, sem acentos, separador "_"
 */
export function slugifyName(input: string): string {
  if (!input) return '';
  const noAccents = input.normalize('NFD').replace(/\p{Diacritic}+/gu, '');
  const lettersOnly = noAccents.replace(/[^a-zA-Z0-9\s]+/g, ' ');
  const collapsed = lettersOnly.trim().replace(/\s+/g, '_');
  return collapsed.toLowerCase();
}

export type BuildPreOrcamentoDirParams = {
  baseDir?: string; // ex.: D:\\ORCAMENTO
  userId: number | string;
  userName: string;
  date?: Date;
  cliWhatsapp: string; // somente dígitos (normalizado)
  nomeSimplificado?: string; // usado somente quando !hasCadastro
  hasCadastro: boolean;
  clienteId?: number | string; // quando hasCadastro
  clienteNomeFantasia?: string; // quando hasCadastro
  categoriaId?: number; // ID da categoria (1-4) - usado para mapeamento
  categoriaNome?: string; // nome da API (fallback)
};

/**
 * Gera o caminho final de salvamento conforme o padrão definido.
 *
 * Com cadastro:
 *   D:\\ORCAMENTO\\{user_id}_{user_name}\\{ano}\\{mês}\\{dia}\\{cli_whatsapp}
 * Sem cadastro:
 *   D:\\ORCAMENTO\\{user_id}_{user_name}\\{ano}\\{mês}\\{dia}\\{cli_whatsapp}_{nome_simplificado}
 * 
 * Onde:
 * - {ano} = 2025
 * - {mês} = 01-Janeiro, 02-Fevereiro, 03-Março, etc.
 * - {dia} = 01, 02, 03, etc.
 */
export function buildPreOrcamentoDir(params: BuildPreOrcamentoDirParams): string {
  // Delegar para o engine central em fileNaming.ts
  return buildPreOrcamentoDirFromParams(params);
}

/** 
 * Gera nome de arquivo único para pré-orçamento com normalização
 * Formato: {cli}{namePart}{YYYYMMDD}{HHmmssSSS}{userIdPad3}.cdr
 * 
 * @param cliWhatsappDigits - Dígitos do WhatsApp (já normalizado)
 * @param userId - ID do usuário
 * @param date - Data de criação (padrão: agora)
 * @param nomeOpcional - Nome opcional quando sem cadastro
 * @param clienteNomeFantasia - Nome fantasia do cliente quando cadastrado
 * @param hasCadastro - Se tem cliente cadastrado
 */
export function generatePreOrcFileName(
  cliWhatsappDigits: string,
  userId: number | string,
  date: Date = new Date(),
  nomeOpcional?: string,
  clienteNomeFantasia?: string,
  hasCadastro?: boolean
): string {
  // Delegar para o engine central com todos os parâmetros
  return generatePreOrcFileNameFromParams(
    cliWhatsappDigits,
    userId,
    date,
    nomeOpcional,
    clienteNomeFantasia,
    hasCadastro
  );
}


